import { render, staticRenderFns } from "./AppTimeline.vue?vue&type=template&id=879a380c&scoped=true&"
import script from "./AppTimeline.vue?vue&type=script&lang=js&"
export * from "./AppTimeline.vue?vue&type=script&lang=js&"
import style0 from "./AppTimeline.vue?vue&type=style&index=0&id=879a380c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "879a380c",
  null
  
)

export default component.exports